import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const AdPrices = {
  List: lazyNamed(() => import('./containers/AdPricesList/index.tsx'), 'AdPricesList'),
  Form: lazyNamed(() => import('./containers/AdPriceForm/index.tsx'), 'AdPriceForm'),
  AdPriceHistory: lazyNamed(() => import('./containers/AdPriceHistory.tsx'), 'AdPriceHistory'),
};
